import React from 'react';
import { US_STATES, CA_PROVINCES } from '../constants/addressRegions';

// Default wrapper uses the shared form-field classes; pages with their own
// field chrome (Editorial Field, EditorField) pass `Field`.
const DefaultField = ({ label, htmlFor, children }) => (
  <div className="form-field">
    <label className="form-field__label" htmlFor={htmlFor}>{label}</label>
    {children}
  </div>
);

/**
 * Country, state/province and postal code as one unit.
 *
 * `country` may be null (legacy rows): it DISPLAYS as United States but is never
 * written back unless the user changes it. onChange always receives the full
 * triple { country, state, zip_code } plus { countryChanged }; a country switch
 * clears state and postal (an impossible pair otherwise).
 * onBlur(name) fires for 'state' and 'zip_code' so the page can save that field.
 */
export default function AddressRegionFields({
  country,
  state,
  postal,
  onChange,
  onBlur,
  Field = DefaultField,
  inputClass = 'form-field__input',
  selectClass = 'form-field__select',
  rowClass = 'form-row-nested',
}) {
  const shown = country === 'CA' ? 'CA' : 'US';
  const isCA = shown === 'CA';
  const regions = isCA ? CA_PROVINCES : US_STATES;

  const emit = (patch, countryChanged = false) => {
    if (onChange) onChange({ country, state: state || '', zip_code: postal || '', ...patch }, { countryChanged });
  };

  return (
    <>
      <Field label="Country" htmlFor="country" empty={false}>
        <select aria-label="Country" id="country" name="country" value={shown} className={selectClass}
          onChange={(e) => emit({ country: e.target.value, state: '', zip_code: '' }, true)}>
          <option value="US">United States</option>
          <option value="CA">Canada</option>
        </select>
      </Field>
      <div className={rowClass}>
        <Field label={isCA ? 'Province' : 'State'} htmlFor="state" empty={!state}>
          <select aria-label={isCA ? 'Province' : 'State'} id="state" name="state" value={state || ''}
            className={selectClass}
            onChange={(e) => emit({ state: e.target.value })}
            onBlur={() => onBlur && onBlur('state')}>
            <option value="">Select...</option>
            {regions.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </Field>
        <Field label={isCA ? 'Postal code' : 'ZIP code'} htmlFor="zip_code" empty={!postal}>
          <input aria-label={isCA ? 'Postal code' : 'ZIP code'} id="zip_code" name="zip_code" type="text"
            value={postal || ''} className={inputClass}
            placeholder={isCA ? 'L9G 4Z6' : '12345'}
            autoComplete="postal-code"
            onChange={(e) => emit({ zip_code: e.target.value })}
            onBlur={() => onBlur && onBlur('zip_code')} />
        </Field>
      </div>
    </>
  );
}
